import request from '../utils/request'

export function getAdminUsers(params) {
  return request({
    url: '/api/admin/users',
    method: 'get',
    params
  })
}

export function createAdminUser(data) {
  return request({
    url: '/api/admin/users',
    method: 'post',
    data
  })
}

export function updateAdminUser(id, data) {
  return request({
    url: `/api/admin/users/${id}`,
    method: 'put',
    data
  })
}

export function enableAdminUser(id) {
  return request({
    url: `/api/admin/users/${id}/enable`,
    method: 'post'
  })
}

export function disableAdminUser(id) {
  return request({
    url: `/api/admin/users/${id}/disable`,
    method: 'post'
  })
}

export function resetAdminPassword(id, data) {
  return request({
    url: `/api/admin/users/${id}/reset-password`,
    method: 'post',
    data
  })
}
